import GasTankIcon from './GasTankIcon'

export default GasTankIcon
